import $ from "jquery";
$(window).on('load', function () {

    if (typeof Vimeo === 'undefined' || typeof window.dataLayer === 'undefined') {
        console.warn('Vimeo Player API or dataLayer is not available.');
        return;
    }

    const trackedVideos = $('iframe[data-event-label]');

    if (trackedVideos.length === 0) {
        return;
    }
    trackedVideos.each(function () {
        const videoIframe = this;


        try {
            const player = new Vimeo.Player(videoIframe);

            const $videoIframe = $(videoIframe);
            const eventLabel = $videoIframe.attr('data-event-label');
            const pageName = $videoIframe.attr('data-page-name');

            if (!eventLabel || !pageName) return;

            const progress = {
                tracked25: false, tracked50: false, tracked75: false, tracked100: false,
            };

            const pushToDataLayer = (action) => {
                window.dataLayer.push({
                    event: 'video', event_category: 'vimeo', event_action: action,
                    event_label: eventLabel, page_name: pageName,
                });
            };

            player.on('play', () => { pushToDataLayer('vimeo_video_play'); });
            player.on('pause', () => { pushToDataLayer('vimeo_video_pause'); });
            player.on('ended', () => {
                if (!progress.tracked100) {
                    progress.tracked100 = true;
                    pushToDataLayer('vimeo_video_100%_complete');
                }
            });
            player.on('timeupdate', (data) => {
                const percent = data.percent * 100;
                if (percent >= 25 && !progress.tracked25) {
                    progress.tracked25 = true;
                    pushToDataLayer('vimeo_video_25%_complete');
                }
                if (percent >= 50 && !progress.tracked50) {
                    progress.tracked50 = true;
                    pushToDataLayer('vimeo_video_50%_complete');
                }
                if (percent >= 75 && !progress.tracked75) {
                    progress.tracked75 = true;
                    pushToDataLayer('vimeo_video_75%_complete');
                }
            });

        } catch (error) {
            console.error('Error al inicializar el reproductor de Vimeo:', error);
            console.error('El elemento que causó el error:', videoIframe);
        }
    });
});